import { inject, injectable } from 'inversify';
import uuid from 'uuid/v4';
import { observable, makeObservable, action } from 'mobx';
import { History } from 'history';
import { iocNames } from '../iocNames';
import { UtcomApi } from './UtcomApi';
import { AxiosError, AxiosResponse } from 'axios';
import { restErrorsToForm } from '@unitedtraders/microfrontend-common';
import { ConvertResponse, Money } from '@unitedtraders/utcom-api-sdk';

@injectable()
export class ConversionService {
  @observable
  currencyFrom: string = 'RUB';

  @observable
  amountFrom: Money | undefined;

  @observable
  amountTo: Money | undefined;

  constructor(
    @inject(iocNames.history) private history: History,
    @inject(iocNames.utcomApi) private utcomApi: UtcomApi
  ) {
    makeObservable(this);
  }

  exchange = async (amount: number) => {
    try {
      const response: AxiosResponse<ConvertResponse> =
        await this.utcomApi.convertClientService.convert({
          amountFrom: {
            value: amount,
            currency: this.currencyFrom,
          },
          currencyTo: this.currencyFrom === 'USD' ? 'RUB' : 'USD',
          requestId: uuid(),
        });

      this.amountFrom = response.data.amountFrom;
      this.amountTo = response.data.amountTo;

      this.history.push('/success');
    } catch (e: AxiosError | any) {
      return restErrorsToForm(e.response?.data || e);
    }
    return null;
  };

  @action
  changeCurrencyFrom = (currencyFrom: string) => {
    this.currencyFrom = currencyFrom;
  };
}
